import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2, ScanLine } from "lucide-react";
import { API } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        const r = await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(r.data);
      } catch (e) {
        console.error("Auth exchange failed", e);
      }
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/", { replace: true, state: { user: true } });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen grid-texture flex flex-col items-center justify-center gap-4">
      <div className="relative flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/15 ring-1 ring-primary/30">
        <ScanLine className="h-7 w-7 text-primary" />
        <div className="scanline-bar" />
      </div>
      <div className="flex items-center gap-2 text-muted-foreground text-sm">
        <Loader2 className="h-4 w-4 animate-spin" /> Signing you in…
      </div>
    </div>
  );
};
